// extracted by mini-css-extract-plugin
export default {"inputs":"PrimaryBriefingInputForm_inputs__UwfZK","textarea_description":"PrimaryBriefingInputForm_textarea_description__H7n9l"};